import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const FormTemplateContainer = styled.div`
  padding: 0 60px;
`;

export const FormTemplateHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FormTemplateHeaderTitle = styled.div``;

export const FormTemplateHeaderStep = styled.span`
  color: ${colors.textSecondary};
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
`;

export const FormTemplateHeaderInfo = styled.h5`
  color: ${colors.textPrimary};
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
`;

export const FormTemplateContent = styled.div``;

export const Form = styled.form`
  height: 100%;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: ${prop => prop.col ? `repeat(${prop.col}, 1fr)` : 'repeat(2, 1fr)'};
  grid-gap: 30px;
  margin-top: 30px;
`;

export const FormRowBorder = styled.div`
  display: grid;
  grid-template-columns: ${prop => prop.col ? `repeat(${prop.col}, 1fr)` : 'repeat(2, 1fr)'};
  grid-gap: 30px;
  margin-top: 30px;
  border: 2px solid #DDDDDD;
  border-radius: 9px;
  margin-bottom: 30px;
`;

export const FormRow3Columns = styled.div`
  display: grid;
  flex-wrap: wrap;
  grid-gap: 30px;
  margin-top: 30px;
`;

export const FormRowInvisible = styled.div`
  display: none;
  grid-template-columns: ${prop => prop.col ? `repeat(${prop.col}, 1fr)` : 'repeat(2, 1fr)'};
  grid-gap: 30px;
  margin-top: 30px;
`;

export const FormFooter = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: ${prop => prop.justify};
`;

export const FormFooterRigth = styled.div`
  margin-top: 40px;
  text-align: right;
  justify-content: ${prop => prop.justify};
`;

